import { AppBar, Container, makeStyles, Toolbar } from "@material-ui/core";
import { AnimateSharedLayout } from "framer-motion";
import InviteLanding from "pages/Invitation";
import { NotFound } from "pages/NotFound";
import Prelanding from "pages/PreLanding";

import React from "react";
import { Helmet } from "react-helmet";
import { Route, Switch, useLocation } from "react-router-dom";
import ZennyaLogo from "zennya.svg";
import AdditionalMedicalInfo from "./AdditionalMedicalInfo";
import BasicInformation from "./BasicInformation";
import CorporateIdLinking from "./CorporateIdLinking";
import DependentDetails from "./DependentDetails";
import Finalize from "./Finalize";
import { HealthPass } from "./HealthPass";
import MedicalId from "./MedicalId";

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    padding: theme.spacing(1),
  },
  logoContainer: {
    height: 92,
    width: "100%",
    marginTop: "100px",
    position: "relative",
    marginLeft: "0px",
  },
}));
const ActionLayout = () => {
  const classes = useStyles();

  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Zennya Onboarding</title>
        <meta name="description" content="Zennya Onboarding" />
      </Helmet>
      <AnimateSharedLayout exitBeforeEnter initial>
        <AppBar position="sticky" color="primary">
          <Toolbar>
            <Container fixed>
              <ZennyaLogo className={classes.logo} />
            </Container>
          </Toolbar>
        </AppBar>
        <Switch location={location} key={location.pathname}>
          <Route exact path="/invites">
            <InviteLanding />
          </Route>
          <Route exact path="/onboarding">
            <Prelanding />
          </Route>
          <Route exact path="/onboarding/medical">
            <MedicalId />
          </Route>
          <Route exact path="/onboarding/linkid">
            <CorporateIdLinking />
          </Route>
          <Route exact path="/onboarding/dependent">
            <DependentDetails />
          </Route>
          <Route exact path="/onboarding/basicinfo">
            <BasicInformation />
          </Route>
          <Route exact path="/onboarding/medical2">
            <AdditionalMedicalInfo />
          </Route>
          <Route exact path="/onboarding/finalize">
            <Finalize />
          </Route>
          <Route exact path="/onboarding/healthpass">
            <HealthPass />
          </Route>
          <Route>
            <NotFound bar />
          </Route>
        </Switch>
      </AnimateSharedLayout>
    </>
  );
};

export { ActionLayout };
